import Accordion from '@carvana/ds-accordion';
import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useCallback, useContext } from 'react';
import { ANALYTICS_EVENTS } from '~/constants/flp/analyticsEvents';
import { DATADOG_EVENTS } from '~/constants/flp/datadogEvents';
import { SortedArticle } from '~/contracts/flp/Article';

type OwnProps = {
  page: string;
  data: SortedArticle;
};

export default function AccordionPanel({ page, data }: OwnProps) {
  const { trackEvent } = useContext(AnalyticsContext);

  const handleOpen = useCallback(
    (isOpen: boolean) => {
      if (!isOpen) return;

      const events =
        page === 'marketing'
          ? {
              eventable: ANALYTICS_EVENTS.MARKETING.CLICKS_FAQ,
              datadog: DATADOG_EVENTS.MARKETING.CLICKS_FAQ
            }
          : {
              eventable: ANALYTICS_EVENTS.PREQUALIFIED.CLICKS_FAQ,
              datadog: DATADOG_EVENTS.PREQUALIFIED.CLICKS_FAQ
            };
      const heading = data?.heading;
      const key = data?.key;
      datadogRum.addAction(events.datadog, { heading, key });
      trackEvent(events.eventable, { heading, key });
    },
    [data?.heading, data?.key, page, trackEvent]
  );

  return (
    <Accordion
      classes={{ container: 'py-0', header: 'py-2xl' }}
      testId="faq-panel"
      headerText={data.heading}
      onExpandedChange={handleOpen}
    >
      {data.content}
    </Accordion>
  );
}
